import React from 'react';
import { MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { PublicClientApplication } from '@azure/msal-browser';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { msalConfig } from './authConfig';
import { Home, Page, Login, Users, User, Schedules, Schedule, Instance } from './pages';
import NavBar from './components/NavBar';
import { UserProvider } from './contexts/user';
import { AuthenticatedLayout, GridContainer, RedirectToPage } from './components';
import './styles/globals.scss';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { UpdateHubProvider } from './contexts/hub/updates';

const queryClient = new QueryClient();
const msalInstance = new PublicClientApplication(msalConfig);

const PublicRoutes = () => {
    return (
        <Switch>
            <Route exact path="/login">
                <Login />
            </Route>
        </Switch>
    );
};

const PermissionRoute = ({ permission, children, ...rest }) => {
    return (
        <Page permission={permission}>
            <Route {...rest}>{children}</Route>
        </Page>
    );
};

const AuthenticatedRoutes = () => {
    return (
        <AuthenticatedLayout>
            <Switch>
                <Route exact path="/">
                    <Home />
                </Route>
                <PermissionRoute exact path="/users" permission="nu">
                    <Users />
                </PermissionRoute>
                <PermissionRoute exact path="/users/:id" permission="nu">
                    <User />
                </PermissionRoute>
                <PermissionRoute exact path="/schedules" permission="ns">
                    <Schedules />
                </PermissionRoute>
                <PermissionRoute exact path="/schedules/:id" permission="ns">
                    <Schedule />
                </PermissionRoute>
                <Route exact path="/instance/:id">
                    <Instance />
                </Route>
            </Switch>
        </AuthenticatedLayout>
    );
};

const App = () => {
    return (
        <MsalProvider instance={msalInstance}>
            <QueryClientProvider client={queryClient}>
                <UserProvider>
                    <UpdateHubProvider>
                        <BrowserRouter>
                            <NavBar />
                            <GridContainer className="w-full pt-24 p-6">
                                <PublicRoutes />
                                <AuthenticatedRoutes />
                                <UnauthenticatedTemplate>
                                    <RedirectToPage page="/login" />
                                </UnauthenticatedTemplate>
                                <ToastContainer />
                            </GridContainer>
                        </BrowserRouter>
                    </UpdateHubProvider>
                </UserProvider>
            </QueryClientProvider>
        </MsalProvider>
    );
};

export default App;
